// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import UserPhoneNumberCell from './UserPhoneNumberCell'
import UserGenderCell from './UserGenderCell'
import UserLocationCell from './UserLocationCell'
import {UserStatusCell} from './UserStatusCell'
import {UserActionsCell} from './UserActionsCell'
import UserDateCell from './UserDateCell'
import {InstructorInfoCell} from './InstructorInfoCell'
import UserStripeIdCell from './UserStripeIdCell'
import AppliedFeeCell from './AppliedFeeCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: '_id',
  //   accessor: '_id',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  // },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Booking ID' className='min-w-125px' />
    ),
    id: '_id',
    accessor: '_id',
    Cell: ({...props}) => <UserPhoneNumberCell phone={props.data[props.row.index]._id} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
    ),
    id: 'user',
    accessor: 'user',
    Cell: ({...props}) => <InstructorInfoCell user={props.data[props.row.index].user} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Reservations Name' className='min-w-175px' />
    ),
    id: 'reservationName',
    accessor: 'reservationName',
    Cell: ({...props}) => {
      return (
        <>
          <div>{props.data[props.row.index].reservationName}</div>
        </>
      )
    },
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Persons' className='min-w-125px' />
    ),
    id: 'person',
    accessor: 'person',
    Cell: ({...props}) => {
      return (
        <>
          <div>{props.data[props.row.index].person}</div>
        </>
      )
    },
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='total cost' className='min-w-125px' />
    ),
    id: 'totalCost',
    accessor: 'totalCost',
    Cell: ({...props}) => {
      return (
        <>
          <div>
            {props.data[props.row.index].total === '0ON DONATION'
              ? '	0 ON DONATION'
              : props.data[props.row.index].total}
          </div>
        </>
      )
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Stripe ID' className='min-w-125px' />
    ),
    id: 'stripeId',
    accessor: 'stripeId',
    Cell: ({...props}) => (
      <UserStripeIdCell stripeId={props?.data[props.row.index]?.transaction?.stripeId} />
    ),
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Booking Fee' className='min-w-125px' />
    ),
    id: 'appliedFee',
    accessor: 'appliedFee',
    Cell: ({...props}) => (
      <AppliedFeeCell appliedFee={props.data[props.row.index].appliedFee} />
    ),
  },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='End Time' className='min-w-125px' />
  //   ),
  //   id: 'endTime',
  //   accessor: 'endTime',
  //   Cell: ({...props}) => <UserDateCell phone={props.data[props.row.index].endTime} />,
  // },

  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Date' className='min-w-125px' />,
    id: 'createdAt',
    accessor: 'createdAt',
    Cell: ({...props}) => <UserDateCell phone={props.data[props.row.index].createdAt} />,
  },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
  //   ),
  //   id: 'email',
  //   accessor: 'email',
  //   Cell: ({...props}) => <UserGenderCell gender={props.data[props.row.index].email} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Type' className='min-w-125px' />
  //   ),
  //   id: 'role',
  //   accessor: 'role',
  //   Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].role} />,
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />
  //   ),
  //   id: 'isBlocked',
  //   accessor: 'isBlocked',
  //   Cell: ({...props}) => <UserStatusCell isBlocked={props.data[props.row.index].isBlocked} />,
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Location' className='min-w-125px' />
  //   ),
  //   id: 'primaryLocation',
  //   accessor: 'primaryLocation',
  //   Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].primaryLocation} />,
  // },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-125px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index]._id} />,
  },
]

export {usersColumns}
